import { render, staticRenderFns } from "./ProductListingCreateScreen.vue?vue&type=template&id=00b8e14e&"
import script from "./ProductListingCreateScreen.vue?vue&type=script&lang=js&"
export * from "./ProductListingCreateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports